import {
  AdvertisingBanner,
  BannerContent,
  BannerStarWrap,
  MainBannerWrapper,
  StyledSlider,
  TextContent,
} from "./styled";
import Typography from "../../../components/Typography";
import { useGetBannersQuery } from "../../../api/bannersApi";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { LinksSocial } from "../../../components/LinksSocial";

const settings = {
  fade: true,
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  waitForAnimate: false,
  arrows: false,
  dotsClass: "slick-dots-custom",
  autoplay: true,
  autoplaySpeed: 5000,
};

export const Banner = () => {
  const { data: bannersData = [] } = useGetBannersQuery();

  return (
    <div className="slider-container">
      <StyledSlider {...settings} dots={!!bannersData.length}>
        <div>
          <MainBannerWrapper>
            <BannerStarWrap>
              <BannerContent>
                <TextContent>
                  <Typography variant="h1">
                    IT-Radio: подкасты и&nbsp;музыка
                  </Typography>
                  <Typography>
                    Когда знаешь, что IT – не просто работа, а стиль жизни.
                    Улетные подкасты, реальные истории и звук, {"\n"}который
                    заряжает.
                  </Typography>
                </TextContent>
                <LinksSocial />
                {/* <MobileAppInfo /> */}
              </BannerContent>
            </BannerStarWrap>
          </MainBannerWrapper>
        </div>
        {bannersData.map((banner, index) => (
          <div key={index}>
            <AdvertisingBanner
              href={banner.url}
              onDragStart={(e) => e.preventDefault()}
              draggable="false"
              target="_blank"
            >
              <img src={banner.desktop} alt="" />
            </AdvertisingBanner>
          </div>
        ))}
      </StyledSlider>
    </div>
  );
};
